import UI from "@alpinejs/ui"
import Mask from '@alpinejs/mask'
import Focus from "@alpinejs/focus"
import Collapse from '@alpinejs/collapse'
import Persist from '@alpinejs/persist'
import Alpine from "alpinejs"

Alpine.plugin(UI)
Alpine.plugin(Mask)
Alpine.plugin(Focus)
Alpine.plugin(Persist)
Alpine.plugin(Collapse)

Alpine.magic('clipboard', () => {
  return (subject) => {
    navigator.clipboard.writeText(subject)
    return true
  }
})

export default Alpine
